// extracted by mini-css-extract-plugin
module.exports = {"container":"_16Z6odIX_f02umE4Amjsyu"};